// extracted by mini-css-extract-plugin
module.exports = {"container":"listInfo_container___GZLT","section-title":"listInfo_section-title__1Wwmg","info-list":"listInfo_info-list__984an"};